import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { IconDefaults } from './providers/IconDefaults';
import { PlatformFeatureFlagsProvider } from './providers/PlatformFeatureFlagsProvider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PlatformFeatureFlagsProvider>
      <IconDefaults>
        <App />
      </IconDefaults>
    </PlatformFeatureFlagsProvider>
  </StrictMode>,
);
